module.exports = __webpack_public_path__ + "img/designs-479.7bbe71a.png";